import type { GameDef } from '../registry';
import { formatTime } from './engine';

/**
 * Rounds are practice-only until the image set's backdrop leakage is fixed: every genuine
 * picture is a POP MART studio render and every counterfeit an amateur phone photo, so a
 * player can learn the backdrop instead of the doll. Scores would be meaningless.
 * See docs/IMAGE-SOURCING.md. Flip this to false once both classes carry both photo styles.
 */
export const PRACTICE_ONLY = true;

/** the picker's view of the game; the view imports this and the registry imports index.ts */
export const luOrLabuDef: Omit<GameDef, 'mount'> = {
  id: 'luorlabu',
  title: 'Lu or Labu',
  icon: '👹',
  blurb: 'Real Labubu, or a knock-off "lafufu"? Find every real one before the bar runs out — some rounds hide two, some hide none.',
  howTo: [
    'Each round deals six plush dolls. Tap the real Labubu. There is no confirm — your finger lands, your answer is in.',
    'Careful: some rounds hold two real ones, and the round only ends when you have found both.',
    'Some rounds hold none at all. That is what the NO LABUBU bar is for.',
    'Press and hold a doll to study its face up close. It costs you nothing but the clock — and the clock is the score.',
    'A wrong tap, a wrong call or running out of time costs 2 seconds and ends the round.',
    'Tells: a real Labubu has nine sharp teeth with gaps, a pale peach face and rosy cheeks. Fakes have mushy teeth and flat, wrong-coloured faces.',
  ],
  scoreLabel: 'time',
  lowerIsBetter: true,
  formatScore: formatTime,
};
